import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { geofenceService } from '../services/api';
import GeofenceForm from '../components/geofence/GeofenceForm';

const CreateGeofence = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Handle form submission
  const handleSubmit = async (geofenceData) => {
    try {
      setIsSubmitting(true);
      
      // In a real app, we would call API
      // const response = await geofenceService.createGeofence(geofenceData);
      
      // For demo, just simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      toast.success('Geofence created successfully');
      navigate('/geofences');
    } catch (err) {
      toast.error('Failed to create geofence');
      console.error('Error creating geofence:', err);
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center">
        <Link to="/geofences" className="mr-4">
          <FiArrowLeft className="text-gray-500 hover:text-primary" size={20} />
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Create Geofence</h1>
          <p className="text-gray-600">Define a new geographic boundary</p>
        </div>
      </div>
      
      {/* Geofence form */}
      <GeofenceForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
    </div>
  );
};

export default CreateGeofence;